import { Button, Modal } from "antd";
import { useState } from "react";
import TabsSupplierCodes from "./TabsSupplierCodes";
import BasicButton from "components/BasicButton/BasicButton";
import Heading from "components/Heading/Heading";

function ModalSupplierCodes() {
  const [openModalCustomerCodes, setOpenModalCustomerCodes] = useState(false);

  return (
    <>
      <Heading name={"المودرين"} />
      <BasicButton>
        <Button
          className="w-[150px] h-8"
          type="primary"
          onClick={() => setOpenModalCustomerCodes(true)}
        >
          اضافه
        </Button>
      </BasicButton>
      <Modal
        title="اضافه اكود الموردين"
        style={{ top: 20 }}
        open={openModalCustomerCodes}
        onOk={() => setOpenModalCustomerCodes(false)}
        onCancel={() => setOpenModalCustomerCodes(false)}
        width={1200}
        footer={false}
      >
        <TabsSupplierCodes />
      </Modal>
    </>
  );
}

export default ModalSupplierCodes;
